import script from "./reportOverdueItems.vue?vue&type=script&setup=true&lang=js"
export * from "./reportOverdueItems.vue?vue&type=script&setup=true&lang=js"

import "./reportOverdueItems.vue?vue&type=style&index=0&id=2c9202d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c9202d6"]])

export default __exports__